import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  openAlert: `${NAMESPACE}_ALERTS_OPEN`,
  closeAlert: `${NAMESPACE}_ALERTS_CLOSE`
};

export const actionCreators = {
  openAlert: (payload) => ({ type: actions.openAlert, payload }),
  closeAlert: (payload) => ({ type: actions.closeAlert, payload })
};

export default {
  actions,
  actionCreators
};
